import { createSelector } from 'reselect';
import { IState } from '../../../typescript/redux/interfaces'

const getState = (state: IState) => state;
const getChat = (state: IState) => state.chat;
const getChatMemo = createSelector([getChat], chat => chat);

export { getChat,getState,getChatMemo };
